<template>
  <div class="max-w-md mx-auto border rounded shadow-xl p-10 mt-10">
    <FeedbackMessage :feedback="feedback" :resetFeedback="resetFeedback" />

    <form @submit="login">
      <div>
        <label class="label-style">Username</label>
        <input
          class="input-style mb-3"
          type="text"
          v-model="username"
          placeholder="Enter username"
          required
        />
      </div>

      <div>
        <label class="label-style">Password</label>
        <input
          class="input-style"
          type="password"
          v-model="password"
          placeholder="Enter password"
          required
        />
      </div>

      <button class="mt-4 py-2 px-3 bg-STblue text-white w-full rounded">
        Submit
      </button>
    </form>
  </div>
</template>

<script>
// THIS COMPONENT IS ONLY USED FOR TESTING LOGGING IN IN DEVELOPMENT

import Layout from "./Layout.vue";
import FeedbackMessage from "../components/FeedbackMessage.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Login",

  components: {
    Layout,
    FeedbackMessage,
  },

  data() {
    return {
      username: "",
      password: "",
    };
  },

  computed: {
    ...mapGetters(["feedback"]),
  },

  methods: {
    ...mapActions(["resetFeedback"]),

    login(event) {
      event.preventDefault();
      this.error = null;
      this.$store.dispatch('login', {
        username: this.username,
        password: this.password,
      }).then(() => {
        // this.$router.push({name: 'Careers'});
      }).catch(error => {
        if (error.response) {
          this.error = error.response.data.error;
        } else {
          console.log(error.message);
        }
      })
    },
  },
};
</script>

<style scoped>
.required:after {
  content: "*";
  color: black;
}

.label-style {
  @apply block text-STblue font-bold mb-2;
}

.input-style {
  @apply shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none;
}
</style>
